import _defineProperty from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React, { forwardRef, useRef, useState } from 'react';
import { useExtractedMargins, InputWrapper, Input } from '@mantine/core';
import { useUuid, useUncontrolled, useDidUpdate, useMergedRef } from '@mantine/hooks';
import dayjs from 'dayjs';
import { TimeField } from './TimeField/TimeField.js';
import { createTimeHandler } from './create-time-handler/create-time-handler.js';
import { getTimeValues } from './get-time-values/get-time-value.js';
import useStyles from './TimeInput.styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var TimeInput = forwardRef(function (_a, ref) {
  var _b = _a,
    required = _b.required,
    label = _b.label,
    error = _b.error,
    description = _b.description,
    className = _b.className,
    style = _b.style,
    _b$size = _b.size,
    size = _b$size === void 0 ? "sm" : _b$size,
    wrapperProps = _b.wrapperProps,
    classNames = _b.classNames,
    styles = _b.styles,
    id = _b.id,
    value = _b.value,
    defaultValue = _b.defaultValue,
    onChange = _b.onChange,
    _b$withSeconds = _b.withSeconds,
    withSeconds = _b$withSeconds === void 0 ? false : _b$withSeconds,
    name = _b.name,
    hoursLabel = _b.hoursLabel,
    minutesLabel = _b.minutesLabel,
    secondsLabel = _b.secondsLabel,
    _b$disabled = _b.disabled,
    disabled = _b$disabled === void 0 ? false : _b$disabled,
    sx = _b.sx,
    others = __objRest(_b, ["required", "label", "error", "description", "className", "style", "size", "wrapperProps", "classNames", "styles", "id", "value", "defaultValue", "onChange", "withSeconds", "name", "hoursLabel", "minutesLabel", "secondsLabel", "disabled", "sx"]);
  var _useStyles = useStyles({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "TimeInput"
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useExtractedMargins = useExtractedMargins({
      others: others,
      style: style
    }),
    mergedStyles = _useExtractedMargins.mergedStyles,
    rest = _useExtractedMargins.rest;
  var uuid = useUuid(id);
  var _useUncontrolled = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: new Date(),
      rule: function rule(val) {
        return val instanceof Date;
      },
      onChange: onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _value = _useUncontrolled2[0],
    handleChange = _useUncontrolled2[1];
  var hoursRef = useRef();
  var minutesRef = useRef();
  var secondsRef = useRef();
  var _useState = useState(getTimeValues(_value)),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  useDidUpdate(function () {
    setTime(getTimeValues(_value));
  }, [_value]);
  var handleHoursChange = createTimeHandler({
    onChange: function onChange(val) {
      setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          hours: val
        });
      });
      handleChange(dayjs(_value).set("hours", parseInt(val, 10)).toDate());
    },
    min: 0,
    max: 23,
    maxValue: 2,
    nextRef: minutesRef
  });
  var handleMinutesChange = createTimeHandler({
    onChange: function onChange(val) {
      setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          minutes: val
        });
      });
      handleChange(dayjs(_value).set("minutes", parseInt(val, 10)).toDate());
    },
    min: 0,
    max: 59,
    maxValue: 5,
    nextRef: secondsRef
  });
  var handleSecondsChange = createTimeHandler({
    onChange: function onChange(val) {
      setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          seconds: val
        });
      });
      handleChange(dayjs(_value).set("seconds", parseInt(val, 10)).toDate());
    },
    min: 0,
    max: 59,
    maxValue: 5
  });
  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues({
    required: required,
    label: label,
    error: error,
    description: description,
    className: className,
    style: mergedStyles,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: "TimeInput",
    id: uuid,
    sx: sx
  }, wrapperProps), /* @__PURE__ */React.createElement(Input, __spreadValues({
    component: "div",
    __staticSelector: "TimeInput",
    required: required,
    invalid: !!error,
    onClick: function onClick() {
      return hoursRef.current.focus();
    },
    size: size,
    className: cx(_defineProperty({}, classes.disabled, disabled)),
    classNames: classNames,
    styles: styles,
    disabled: disabled
  }, rest), /* @__PURE__ */React.createElement("div", {
    className: classes.controls
  }, /* @__PURE__ */React.createElement(TimeField, {
    ref: useMergedRef(hoursRef, ref),
    value: time.hours,
    onChange: handleHoursChange,
    setValue: function setValue(val) {
      return setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          hours: val
        });
      });
    },
    id: uuid,
    className: classes.timeInput,
    withSeparator: true,
    size: size,
    max: 23,
    "aria-label": hoursLabel,
    disabled: disabled
  }), /* @__PURE__ */React.createElement(TimeField, {
    ref: minutesRef,
    value: time.minutes,
    onChange: handleMinutesChange,
    setValue: function setValue(val) {
      return setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          minutes: val
        });
      });
    },
    className: classes.timeInput,
    withSeparator: withSeconds,
    size: size,
    max: 59,
    "aria-label": minutesLabel,
    disabled: disabled
  }), withSeconds && /* @__PURE__ */React.createElement(TimeField, {
    ref: secondsRef,
    value: time.seconds,
    onChange: handleSecondsChange,
    setValue: function setValue(val) {
      return setTime(function (c) {
        return __spreadProps(__spreadValues({}, c), {
          seconds: val
        });
      });
    },
    className: classes.timeInput,
    size: size,
    max: 59,
    "aria-label": secondsLabel,
    disabled: disabled
  }), name && /* @__PURE__ */React.createElement("input", {
    type: "hidden",
    name: name,
    value: _value.toISOString()
  }))));
});
TimeInput.displayName = "@mantine/dates/TimeInput";
export { TimeInput };